import { Section } from "@/components/Section";
import { Container } from "@/components/Container";
import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";

const TIERS = [
  {
    name: "Free AI Call",
    price: "$0",
    body: "Twenty minutes. An honest read on whether AI helps you, and where.",
  },
  {
    name: "Assessment & Build",
    price: "Fixed quote",
    body: "Scoped in writing before any work begins, with fixed deliverables and timeline.",
  },
] as const;

export function PricingTeaser() {
  return (
    <Section tone="raised">
      <Container>
        <Reveal className="max-w-[52ch]">
          <Eyebrow>Pricing</Eyebrow>
          <h2 className="mt-3 font-display text-h2 text-ink-900">
            Published rates. Scoped before we start.
          </h2>
          <p className="mt-4 text-body-lg text-ink-500">
            No open-ended retainers, no surprise invoices.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
          {TIERS.map((tier, i) => (
            <Reveal key={tier.name} delay={i * 60} className="h-full">
              <div className="flex h-full flex-col rounded-xl border border-ink-200 bg-paper-0 p-7 shadow-[0_1px_2px_oklch(0.1831_0.0309_263.38_/_0.04),0_8px_24px_-12px_oklch(0.1831_0.0309_263.38_/_0.12)]">
                <h3 className="font-display text-h3 text-ink-900">{tier.name}</h3>
                <p
                  className="mt-3 font-mono text-h2 text-brand-700"
                  style={{ fontVariantNumeric: "tabular-nums" }}
                >
                  {tier.price}
                </p>
                <p className="mt-4 text-body text-ink-600">{tier.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </Section>
  );
}

export default PricingTeaser;
